import * as amplitude from '@amplitude/analytics-browser';
import { AMPLITUDE_API_KEY, PROXIED_AMPLITUDE } from '../../config/constants';
import { isEmpty } from 'lodash';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

const AMPLITUDE_PROXY_PATH = '/proxies/amplitude/2/httpapi';

export const initializeAmplitude = (user) => {
  if (isEmpty(AMPLITUDE_API_KEY)) {
    console.log('Amplitude API key not set');
    return;
  }

  amplitude.init(AMPLITUDE_API_KEY, user?._id, {
    ...(PROXIED_AMPLITUDE && { serverUrl: AMPLITUDE_PROXY_PATH }),
    defaultTracking: {
      pageViews: true,
      sessions: true,
      formInteractions: false,
      fileDownloads: false,
    },
  });

  if (
    !user?._id ||
    user.isDemo ||
    user.isSuperAdmin ||
    user.email.toLowerCase().endsWith('@meeopp.com')
  ) {
    return;
  }

  const sessionReplayTracking = sessionReplayPlugin({ sampleRate: 1 });
  amplitude.add(sessionReplayTracking);
};

export const amplitudeTrack = (eventName, eventProperties) => {
  amplitude.track(eventName, {
    ...eventProperties,
  });
};

export const getAnalyticsUser = () => {
  return {
    deviceId: amplitude.getDeviceId(),
    amplitudeSessionId: amplitude.getSessionId(),
  };
};
